const filterDataInitial = [
	{
		exclude: false,
		id: 1,
		name: 'connection',
		search: false,
		tag: '',
		value: []
	},
	{
		exclude: false,
		id: 2,
		name: 'location',
		search: false,
		tag: '',
		value: []
	},
	{
		exclude: false,
		id: 3,
		name: 'industry',
		search: false,
		tag: '',
		value: []
	},
	{
		exclude: false,
		id: 4,
		name: 'keywords',
		search: true,
		tag: '',
		value: []
	},
	{
		exclude: false,
		id: 5,
		name: 'company',
		search: false,
		tag: '',
		value: []
	},
	{
		exclude: false,
		id: 6,
		name: 'contacted',
		search: false,
		selectId: 9,
		tag: '',
		value: [
			{ id: 1, value: null },
			{ id: 2, value: null }
		]
	},
	{
		exclude: false,
		id: 7,
		name: 'status',
		search: false,
		tag: '',
		value: ''
	},
	{
		exclude: false,
		id: 8,
		name: 'createdSelect',
		search: false,
		value: null
	},
	{
		exclude: false,
		id: 9,
		name: 'contactedSelect',
		search: false,
		value: null
	},
	{
		exclude: false,
		id: 10,
		name: 'campaigns',
		search: false,
		tag: '',
		value: []
	},
	{
		exclude: false,
		id: 11,
		name: 'exclude contactedSelect',
		search: false,
		value: null
	},
	{
		exclude: true,
		id: 12,
		name: 'NOT: keywords',
		search: true,
		tag: '',
		value: []
	},
	{
		exclude: true,
		id: 13,
		name: 'NOT: campaigns',
		search: false,
		tag: '',
		value: []
	},
	{
		exclude: true,
		id: 14,
		name: 'NOT: contacted',
		search: false,
		selectId: 11,
		tag: '',
		value: [
			{ id: 1, value: null },
			{ id: 2, value: null }
		]
	},
	{
		exclude: false,
		id: 15,
		name: 'created',
		search: false,
		selectId: 8,
		tag: '',
		value: [
			{ id: 1, value: null },
			{ id: 2, value: null }
		]
	}
]

export type FilterItem = (typeof filterDataInitial)[number]

export { filterDataInitial }
